import React from 'react'
import Map, {
  FeaturesLayer,
  FavoritesLayer,
  NavigationControl,
  BearingControl,
  GeolocationControl,
  GeolocationMarker,
  RadarControl,
  InfoControl,
  PinControl,
  HashControl,
  TerrainControl
} from '../components/Map'

import SearchControl from '../components/SearchControl'

import {
  useMapExtent,
  useMapView,
  useMapPadding
} from '../slices/map'

const MapView = (props) => {
  const { children, controls } = props
  const extent = useMapExtent()
  const view = useMapView()
  const padding = useMapPadding()

  return (
      <Map extent={extent} view={view} padding={padding}>
        <div className="mapcontrol fade-in delay">
          <BearingControl/>
          <NavigationControl/>
          <GeolocationControl/>
          <TerrainControl/>
          <SearchControl/>
          <RadarControl/>
          { controls }
        </div>
        <FeaturesLayer/>
        <FavoritesLayer/>
        { children }
        <InfoControl/>
        <HashControl/>
        <PinControl/>
        <GeolocationMarker/>
      </Map>
  )
}

export default MapView
